import React from 'react';
import InputComponent from '../../components/input/input';
import ButtonComponent from '../../components/button/button';
import { useNavigate } from 'react-router-dom';
import DatePickerComponent from '../../components/input/input-date';
import { useUserData } from '../../shared/context/user-data-context';
import { Dayjs } from 'dayjs';
import './styles.css';
import { MenuTop } from '../../components/menu/top/menu-top';
import { getPlanUsage, IRemainingUsage } from '../../features/search/service/search-service';
import { useAuthUser } from '../../shared/hooks/use-auth-user';

const LICENSE_LIMIT_MESSAGE = 'Limite de licenças atingido.';
const LICENSE_CONTACT_MESSAGE = 'Para continuar, solicite novas licenças em contato@causale.org ou pelo WhatsApp +55 53 99189-9532.';

const Register = () => {
    const navigate = useNavigate();
    const [name, setName] = React.useState('');
    const [birthDate, setBirthDate] = React.useState<Dayjs | null>(null);
    const [idRegister, setIdRegister] = React.useState('');
    const [licenseUsage, setLicenseUsage] = React.useState<IRemainingUsage | null>(null);
    const [licenseLoading, setLicenseLoading] = React.useState(true);
    const [licenseError, setLicenseError] = React.useState<string | null>(null);
    const { updateUserData } = useUserData();
    const { user, loading: userLoading } = useAuthUser();

    const hasAvailableLicenses = licenseUsage?.status.hasAvailableLicenses ?? false;
    const shouldBlockStart = userLoading || licenseLoading || !!licenseError || !hasAvailableLicenses;

    const handleNext = () => {
        if (shouldBlockStart) {
            return false;
        }

        if(name && birthDate && idRegister) {
            updateUserData({
                record_id: idRegister,
                nome: name,
                dtnasc: birthDate.format('DD/MM/YYYY')
            });

            navigate('/instruction');
        }

        return false;
    }

    React.useEffect(() => {
        const fetchLicenseUsage = async () => {
            const companyId = user?.companyId || user?.company?.id;

            if (!companyId) {
                if (!userLoading) {
                    setLicenseError('Não foi possível identificar a empresa do usuário.');
                    setLicenseLoading(false);
                }
                return;
            }

            try {
                setLicenseLoading(true);
                setLicenseError(null);
                const usage = await getPlanUsage(companyId);
                setLicenseUsage(usage);
            } catch (error) {
                console.error('❌ Erro ao validar licenças:', error);
                setLicenseError('Não foi possível validar as licenças disponíveis. Recarregue a página e tente novamente.');
            } finally {
                setLicenseLoading(false);
            }
        };

        fetchLicenseUsage();
    }, [user, userLoading]);

    const renderLicenseAlert = () => {
        if (userLoading || licenseLoading) {
            return (
                <div className="license-alert license-alert-loading" role="status">
                    Verificando licenças disponíveis...
                </div>
            );
        }

        if (licenseError) {
            return (
                <div className="license-alert" role="alert">
                    {licenseError}
                </div>
            );
        }

        if (!hasAvailableLicenses) {
            return (
                <div className="license-alert" role="alert">
                    <strong>{LICENSE_LIMIT_MESSAGE}</strong>
                    <span>{LICENSE_CONTACT_MESSAGE}</span>
                </div>
            );
        }

        return null;
    };

    return (
        <div>
            <div className='register-container'>
                <MenuTop /> 
                {renderLicenseAlert()}
                <img src="../../../assets/logo-inteira.png" alt="Logo delay discounting"  className="logo" style={{ width: '300px', height: '200px' }}/>
                <InputComponent 
                    id="id-register-input" 
                    label="Registro do usuário" 
                    value={idRegister} 
                    onChange={(event) => {setIdRegister(event.target.value)}} />


                <InputComponent 
                    id="name-input" 
                    label="Nome" 
                    value={name} 
                    onChange={(event) => {setName(event.target.value)}} />
                
                <DatePickerComponent 
                    label="Data de Nascimento"
                    value={birthDate}
                    onChange={(event) => {setBirthDate(event)}} />
                
                <ButtonComponent
                    label="Registar"
                    onClick={handleNext}
                    props={{ disabled: shouldBlockStart }}
                />
            </div>
        </div>
    )
}

export default Register;
